import * as FateActionTypes from 'actiontypes/fate';
import FateService from 'services/FateService';

/** ----------------------------------------------------------------------------
 * FETCH FATE
 -----------------------------------------------------------------------------*/

export default fetch(new FateService());

export function fetch(service) {
  return () => async (dispatch) => {
    dispatch(fetchFateRequested());
    try {
      const { data } = await service.fetchFate();
      dispatch(fetchFateSuccess(data));
    } catch (error) {
      dispatch(fetchFateFailure(error));
    }
  };
}

const fetchFateRequested = () => ({ type: FateActionTypes.FETCH_REQUESTED });

const fetchFateSuccess = data => ({ type: FateActionTypes.FETCH_SUCCESS, payload: data });

const fetchFateFailure = error => ({
  type: FateActionTypes.FETCH_FAILURE,
  error: true,
  status: error.response && error.response.status,
});